export default __webpack_public_path__ + "static/media/cd.ae601d28.svg";